export const dateRangeConfigs = {
  TRANSACTION: "TRANSACTION",
  NON_TRANSACTION: "NON_TRANSACTION",
  NON_TRANSACTION_NO_FUTURE: "NON_TRANSACTION_NO_FUTURE",
  NON_TRANSACTION_NO_FUTURE_WITH_ALL: "NON_TRANSACTION_NO_FUTURE_WITH_ALL",
  NON_TRANSACTION_WITH_ALL: "NON_TRANSACTION_WITH_ALL",
};

export const fixedDateRanges = {
  NONE: null,
  TODAY: "TODAY",
  YESTERDAY: "YESTERDAY",
  IN_X_DAYS: "IN_X_DAYS",
  X_DAYS_AGO: "X_DAYS_AGO",
  NEXT_X_DAYS: "NEXT_X_DAYS",
  LAST_X_DAYS: "LAST_X_DAYS",
  MTD: "MTD",
  THIS_MONTH: "THIS_MONTH",
  LAST_MONTH: "LAST_MONTH",
  NEXT_MONTH: "NEXT_MONTH",
  QTD: "QTD",
  THIS_QUARTER: "THIS_QUARTER",
  LAST_QUARTER: "LAST_QUARTER",
  NEXT_QUARTER: "NEXT_QUARTER",
  YTD: "YTD",
  THIS_YEAR: "THIS_YEAR",
  LAST_YEAR: "LAST_YEAR",
  ALL_DATES: "ALL_DATES",
};

const fullDateRangeList = [
  { value: fixedDateRanges.TODAY, label: "Today", isFuture: false },
  { value: fixedDateRanges.YESTERDAY, label: "Yesterday", isFuture: false },
  { value: fixedDateRanges.IN_X_DAYS, label: "In ... day(s)", isFuture: true },
  {
    value: fixedDateRanges.X_DAYS_AGO,
    label: "... day(s) ago",
    isFuture: false,
  },
  {
    value: fixedDateRanges.NEXT_X_DAYS,
    label: "Next ... day(s)",
    isFuture: true,
  },
  {
    value: fixedDateRanges.LAST_X_DAYS,
    label: "Last ... day(s)",
    isFuture: false,
  },
  { value: fixedDateRanges.MTD, label: "Month To Date", isFuture: false },
  { value: fixedDateRanges.THIS_MONTH, label: "This Month", isFuture: true },
  { value: fixedDateRanges.LAST_MONTH, label: "Last Month", isFuture: false },
  { value: fixedDateRanges.NEXT_MONTH, label: "Next Month", isFuture: true },
  { value: fixedDateRanges.QTD, label: "Quarter To Date", isFuture: false },
  {
    value: fixedDateRanges.THIS_QUARTER,
    label: "This Quarter",
    isFuture: true,
  },
  {
    value: fixedDateRanges.LAST_QUARTER,
    label: "Last Quarter",
    isFuture: false,
  },
  {
    value: fixedDateRanges.NEXT_QUARTER,
    label: "Next Quarter",
    isFuture: true,
  },
  { value: fixedDateRanges.YTD, label: "Year To Date", isFuture: false },
  { value: fixedDateRanges.THIS_YEAR, label: "This Year", isFuture: true },
  { value: fixedDateRanges.LAST_YEAR, label: "Last Year", isFuture: false },
];

const transactionDateRangeListValues = new Set([
  fixedDateRanges.YESTERDAY,
  fixedDateRanges.X_DAYS_AGO,
  fixedDateRanges.LAST_X_DAYS,
  fixedDateRanges.MTD,
  fixedDateRanges.THIS_MONTH,
  fixedDateRanges.LAST_MONTH,
  fixedDateRanges.QTD,
  fixedDateRanges.THIS_QUARTER,
  fixedDateRanges.LAST_QUARTER,
  fixedDateRanges.YTD,
  fixedDateRanges.THIS_YEAR,
  fixedDateRanges.LAST_YEAR,
]);

const nonTransactionDateRangeListValues = new Set([
  fixedDateRanges.TODAY,
  fixedDateRanges.IN_X_DAYS,
  fixedDateRanges.X_DAYS_AGO,
  fixedDateRanges.NEXT_X_DAYS,
  fixedDateRanges.LAST_X_DAYS,
  fixedDateRanges.MTD,
  fixedDateRanges.THIS_MONTH,
  fixedDateRanges.LAST_MONTH,
  fixedDateRanges.NEXT_MONTH,
  fixedDateRanges.QTD,
  fixedDateRanges.THIS_QUARTER,
  fixedDateRanges.LAST_QUARTER,
  fixedDateRanges.NEXT_QUARTER,
  fixedDateRanges.YTD,
  fixedDateRanges.THIS_YEAR,
  fixedDateRanges.LAST_YEAR,
]);

const getNonTransactionNoFutureList = () =>
  fullDateRangeList.filter(
    (opt) => nonTransactionDateRangeListValues.has(opt.value) && !opt.isFuture
  );

const getNonTransactionWithAllList = () =>
  fullDateRangeList.filter((opt) =>
    nonTransactionDateRangeListValues.has(opt.value)
  );

export const fixedDateRangeOptions = (config) => {
  switch (config) {
    case dateRangeConfigs.TRANSACTION:
      return fullDateRangeList.filter((opt) =>
        transactionDateRangeListValues.has(opt.value)
      );

    case dateRangeConfigs.NON_TRANSACTION_NO_FUTURE:
      return getNonTransactionNoFutureList();

    case dateRangeConfigs.NON_TRANSACTION_NO_FUTURE_WITH_ALL:
      return [
        {
          value: fixedDateRanges.ALL_DATES,
          label: "All Dates",
          isFuture: false,
        },
        ...getNonTransactionNoFutureList(),
      ];
    case dateRangeConfigs.NON_TRANSACTION_WITH_ALL:
      return [
        {
          value: fixedDateRanges.ALL_DATES,
          label: "All Dates",
          isFuture: true,
        },
        ...getNonTransactionWithAllList(),
      ];

    case dateRangeConfigs.NON_TRANSACTION:
    default:
      return fullDateRangeList.filter((opt) =>
        nonTransactionDateRangeListValues.has(opt.value)
      );
  }
};
